import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { LnPrimaryButtonComponent } from '@components/butons/ln-primary-button/ln-primary-button.component';
import { MenuActions } from '../../states/menu_actions';
import { TranslocoPipe } from '@jsverse/transloco';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'ln-purchase-summary',
  imports: [LnPrimaryButtonComponent, TranslocoPipe, DecimalPipe],
  templateUrl: './purchase-summary.component.html',
  styleUrl: './purchase-summary.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PurchaseSummaryComponent {
  @Input({ required: true }) subTotal!: number;
  @Input({ required: true }) singleProductAlert!: boolean;
  private menuActions = inject(MenuActions);
  navigateToPurchaseCompletion(): void {
    this.menuActions.navigateToPurchaseCompletion();
  }
}
